import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import $ from 'jquery';
import moment from 'moment';
import { fromEvent, ReplaySubject } from 'rxjs';
import { startWith, takeWhile, tap } from 'rxjs/operators';
import Tabulator from 'tabulator-tables';
import { DisplayMessageMinimum, getStatusIcon, Process, SelectItem, Table } from '../../shared';
import { DisplayErrors, IShowErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { TabulatorService } from '../../tabulator.service';
import { IUserEntryDate } from '../IUserEntryDates';
import { IUserGroups } from '../IUserGroups';

@Component({
    selector: 'ef-userentrydates-presenters',
    templateUrl: './userentrydates-presenters.component.html',
    styleUrls: ['./userentrydates-presenters.component.scss'],
    standalone: false
})
export class UserentrydatesPresentersComponent extends DisplayErrors<IUserEntryDate>
    implements OnInit, AfterViewInit, OnDestroy
{
    @Input() public process: Process;
    private _errors: Array<string>;
    downloadOptions: { label: string; icon: string; command: () => any }[];
    // @Input() public set errors(value: Array<string>) {
    //     this.log.debug({
    //         type: 'UserEntryDatesPresenterComponent:errors:set',
    //         value
    //     });
    //     this._errors = value;
    //     if (value && value.length) {
    //         this.errorHelpText = value
    //             .reduce((a, c) => a + c + '\r\n', '')
    //             .trim();
    //     } else {
    //         this.errorHelpText = '';
    //     }
    //     if (this.tabEntryDates) {
    //         this.tabEntryDates.redraw();
    //     }
    // }
    // public get errors(): Array<string> {
    //     return this._errors;
    // }
    // private _selectedError: IShowErrors;
    // @Input() public set selectedError(value: IShowErrors) {
    //     this.log.debug({
    //         type: 'UserEntryDatesPresenterComponent:selectedError:set',
    //         value
    //     });
    //     if (this.process) {
    //         if (value.MsgProcessID === this.process.ProcessID) {
    //             if (this._selectedError) {
    //                 const prevRow = this.tabEntryDates
    //                     .getRows()
    //                     .find(
    //                         row =>
    //                             row.getData().EmployeeListId ===
    //                             this._selectedError.MsgEntityID
    //                     );
    //                 if (prevRow) {
    //                     prevRow.getElement().classList.remove('highlight');
    //                 }
    //             }
    //             this._selectedError = value;
    //             const theRow = this.tabEntryDates
    //                 .getRows()
    //                 .find(
    //                     row =>
    //                         row.getData().EmployeeListId === value.MsgEntityID
    //                 );
    //             if (theRow) {
    //                 theRow.scrollTo();
    //                 // this.tabEntryDates.scrollToRow(3, 'center', false);
    //                 theRow.getElement().classList.add('highlight');
    //                 // theRow.getElement().css({'background-color': 'green'});
    //                 this.log.debug({
    //                     type: 'UserEntryDatesPresenterComponent:selectedError:set',
    //                     rowElement: theRow.getElement()
    //                 });
    //             }
    //         }
    //     }
    // }
    // public get selectedError(): IShowErrors {
    //     return this._selectedError;
    // }

    employeeSelectItem: SelectItem[] = [];

    EntryDatesSubject = new ReplaySubject<IUserEntryDate[]>(1);
    private _entryDates: Array<IUserEntryDate> = [];
    @Input('entryDates') set entryDates(value: Array<IUserEntryDate>) {
        if (value && value.length > 0) {
            this._entryDates = value.map(x => ({ ...x }));
            this.EntryDatesSubject.next(this._entryDates);

            this.employeeSelectItem = value.map(x => ({
                label: x.EmployeeName,
                value: x.EmployeeListId
            }));
        }

        if (this.tabEntryDates) {
            if (this._entryDates.length > 0) {
                if (this._entryDates.some(x => x.Splitday != null) == true) {
                    this.IsSplitDayVisible = true;
                    this.tabEntryDates.showColumn('Splitday');
                } else {
                    this.IsSplitDayVisible = false;
                    this.tabEntryDates.hideColumn('Splitday');
                }
                //this.tabEntryDates.replaceData(this._entryDates);
                //this.tabEntryDates.redraw(true);

            }
        }

        // this.loadingData = !(value && value.length);
    }
    get entryDates(): Array<IUserEntryDate> {
        return this._entryDates;
    }

    private _groups: Array<IUserGroups>;
    @Input('groups') set groups(value: Array<IUserGroups>) {
        this._groups = value.map(x => ({ ...x }));
        this.arraySort(this._groups);
    }
    get groups(): Array<IUserGroups> {
        return this._groups;
    }

    @Input() entryStartDate: Date;
    @Input() entryEndDate: Date;

    public tabEntryDates;

    public filterFormGroup: UntypedFormGroup;
    public multiUpdateFormGroup: UntypedFormGroup;
    public loadingData = false;
    public todaysDate: Date = new Date();
    public selectedStartDate: Date;
    public selectedEndDate: Date;
    public active = true;
    public selectColumnWidth = 50;
    public selectAllFilteredCount = 0;
    public GroupsDropdownText = 'Groups';
    public selectedRowsCheckbox = { checked: false, indeterminate: false };
    public errorHelpText = '';

    @ViewChild('cbxColumnHeader', { static: true })
    cbxColumnHeader: MatCheckbox;
    @ViewChild('applyMulti', { read: ElementRef, static: true })
    applyUpdatesButton: ElementRef;

    @Output() startDateSelected = new EventEmitter<Date>();
    @Output() endDateSelected = new EventEmitter<Date>();
    @Output() applyClicked = new EventEmitter<Array<IUserEntryDate>>();
    @Output() groupsSelected = new EventEmitter<Array<IUserGroups>>();
    @Output() resetAction = new EventEmitter();
    @Output() public ShowError = new EventEmitter<IShowErrors>();

    public uEDComp: UserentrydatesPresentersComponent = this;

    @ViewChild('UEDTable', { static: true }) UEDTable: Table;

    public editing?: IUserEntryDate = {} as IUserEntryDate;
    clonedEntryDates: { [i: string]: IUserEntryDate } = {};
    @Output() SaveEntryDates = new ReplaySubject<IUserEntryDate>(1);
    @Output() MultiSaveEntryDates = new ReplaySubject<IUserEntryDate[]>(1);

    minWorkDate: Date;
    maxWorkDate: Date;

    uedTableSelection: IUserEntryDate[] = [];

    public moment: any;

    IsSplitDayVisible: boolean;

    latestRowChanged: any;

    constructor(
        @Inject(LoggingService) private log: LoggingService,
        @Inject(TabulatorService) private tabService: TabulatorService
    ) {
        super();
        this.moment = moment;
        this.filterFormGroup = new UntypedFormGroup({
            groups: new UntypedFormControl(null),
            users: new UntypedFormControl(null)
        });

        this.multiUpdateFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
            apply: new UntypedFormControl(null)
        });

        // Catches any changes made to a single row
        this.tabService.rowChanged$
            .pipe(takeWhile(x => this.active))
            .subscribe(row => {
                this.latestRowChanged = row;

                const rowData = row.getData();
                const minDate = new Date(rowData.MinWorkDate.toString());
                const maxDate = new Date(rowData.MaxWorkDate.toString());
                if (row._row.cells[4].oldValue != null) {
                    if (minDate > maxDate) {
                        rowData.MaxWorkDate = rowData.MinWorkDate;
                    }
                }
                if (row._row.cells[5].oldValue != null) {
                    if (maxDate < minDate) {
                        rowData.MinWorkDate = rowData.MaxWorkDate;
                    }
                }

                const data = this.entryDates.find(
                    x => x.EmployeeListId === rowData.EmployeeListId
                );

                this.applyClicked.emit([
                    {
                        ...data,
                        ...rowData
                    }
                ]);
            });
    }

    public downloadTable(type) {
        this.tabEntryDates.download(
            type,
            `${this.process.ProcessTitle}_${moment(new Date()).format(
                'MM-DD-YYYY'
            )}.${type}`,
            { sheetName: 'User Entry Dates' }
        );
    }

    ngOnDestroy() {
        this.active = false;
    }

    ngOnInit() {
        this.downloadOptions = [
            {
                label: 'CSV',
                icon: 'pi pi-download',
                command: () => this.downloadTable('csv')
            },
            {
                label: 'Excel',
                icon: 'pi pi-download',
                command: () => this.downloadTable('xlsx')
            }
        ];
        this.setupSubscriptions();

    }
    setupSubscriptions() {
        this.EntryDatesSubject.pipe(takeWhile(() => this.active)).subscribe(value => {
            if (value && value.length > 0 && this.tabEntryDates == null) {
                //this.createTabulator(this, value, []);
            } else {
                // if (this.latestRowChanged != null) {
                //     var data = value.find(x => x.EmployeeListId == this.latestRowChanged.getData().EmployeeListId);
                //     var rowData = this.latestRowChanged.getData();
                //     this.latestRowChanged.update({
                //         ...rowData,
                //         MinWorkDate: data.MinWorkDate,
                //         MaxWorkDate: data.MaxWorkDate,
                //         Status: data.Status
                //     });
                // }
            }

        });

    }
    ngAfterViewInit() {
        this.multiUpdateFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(
                new Date(
                    this.entryStartDate.getTime() -
                        this.entryStartDate.getTimezoneOffset() * -60000
                )
            ),
            endDate: new UntypedFormControl(
                new Date(
                    this.entryEndDate.getTime() -
                        this.entryStartDate.getTimezoneOffset() * -60000
                )
            ),
            apply: new UntypedFormControl(null)
        });

        this.tabService.tabulator = $('#tabEntryDates');

        this.filterFormGroup.controls['users'].valueChanges
            .pipe(
                startWith([]),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'UserentrydatesPresentersComponent:users:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'UserentrydatesPresentersComponent:users:valueChanges:subscribe',
                    value
                });
                //this.filterData(value, 'EmployeeName', 'EmployeeName');
            });

        this.filterFormGroup.controls['groups'].valueChanges
            .pipe(
                startWith([]),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'UserentrydatesPresentersComponent:groups:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'UserentrydatesPresentersComponent:groups:valueChanges:subscribe',
                    value
                });
                this.groupsSelected.emit(value);
            });

        this.multiUpdateFormGroup.controls['startDate'].valueChanges
            .pipe(
                startWith(this.entryStartDate),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'UserentrydatesPresentersComponent:startDate:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'UserentrydatesPresentersComponent:startDate:valueChanges:subscribe',
                    value
                });
                this.selectedStartDate = value;
                this.startDateSelected.emit(value);
            });

        this.multiUpdateFormGroup.controls['endDate'].valueChanges
            .pipe(
                startWith(this.entryEndDate),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'UserentrydatesPresentersComponent:endDate:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'UserentrydatesPresentersComponent:endDate:valueChanges:subscribe',
                    value
                });
                this.selectedEndDate = value;
                this.startDateSelected.emit(value);
            });

        fromEvent(this.applyUpdatesButton.nativeElement, 'click')
            .pipe(
                tap(_ =>
                    this.log.debug({
                        type: 'UserentrydatesPresentersComponent:applyUpdatesButton:tap:click'
                    })
                ),
                takeWhile(_ => this.active)
            )
            .subscribe(button => {
                this.log.debug({
                    type: 'UserentrydatesPresentersComponent:applyUpdatesButton:subscribe:click'
                });


                // const selectedRows = this.tabEntryDates.getSelectedRows();
                // const selectedRowsData = [];
                // const controls = this.multiUpdateFormGroup.controls;

                // const selectedData = this.tabEntryDates.getSelectedData();
                // selectedData.forEach(data => {
                //     if (controls['startDate'].value) {
                //         data.MinWorkDate = controls['startDate'].value;
                //     }
                //     if (controls['endDate'].value) {
                //         data.MaxWorkDate = controls['endDate'].value;
                //     }
                // });

                // this.applyClicked.emit(
                //     selectedData.map(newData => {
                //         const id = newData.EmployeeListID; // should be uniqueID
                //         const oldData = this.entryDates.find(
                //             x => x.EmployeeListId === id
                //         );
                //         return {
                //             ...oldData, // old values
                //             ...newData // applying new values
                //         };
                //     })
                // );
            });
    }

    arraySort(array: Array<any>) {
        array.sort((a, b) => {
            if (a.GroupName.toLowerCase() === b.GroupName.toLowerCase()) {
                return 0;
            }
            if (
                typeof a.GroupName.toLowerCase() ===
                typeof b.GroupName.toLowerCase()
            ) {
                return a.GroupName < b.GroupName ? -1 : 1;
            }
            return typeof a.GroupName < typeof b.GroupName ? -1 : 1;
        });
    }

    // private createTabulator(
    //     fp: UserentrydatesPresentersComponent,
    //     entryDates: Array<IUserEntryDate>,
    //     errors: Array<string>
    // ) {
    //     let headerClicked = false;
    //     const count = 0;
    //     function checkIndeterminate() {
    //         if (fp.tabEntryDates) {
    //             const rows = fp.tabEntryDates.getRows(true);
    //             const selectedRows: Array<any> = [];
    //             rows.forEach(row => {
    //                 if (row._row.data.selected === true) {
    //                     selectedRows.push(row);
    //                 }
    //             });

    //             fp.cbxColumnHeader.checked = rows.reduce(
    //                 (a, c) => a && c.getData().selected,
    //                 true
    //             );
    //             fp.cbxColumnHeader.indeterminate =
    //                 selectedRows.length > 0 &&
    //                 !rows.reduce((a, c) => a && c.getData().selected, true);
    //         }
    //     }

    //     this.tabEntryDates = new Tabulator('#tabEntryDates', {
    //         placeholder: 'No Data Available',
    //         height: '40vh',
    //         // minWidth: '40vh',
    //         autoResize: true,
    //         layout: 'fitColumns',
    //         data: entryDates,
    //         // TODO: define columns we want to see
    //         // autoColumns:true,
    //         columns: [
    //             {
    //                 title: 'Id',
    //                 field: 'EmployeeListID',
    //                 visible: false
    //             },
    //             // 1 Status
    //             {
    //                 title: '',
    //                 download: false,
    //                 width: fp.selectColumnWidth,
    //                 field: 'Status',
    //                 formatter: (cell, params, onRendered) => {
    //                     const status = cell.getValue();
    //                     if (status) {
    //                         return getStatusIcon(status.StatusCode).iconText;
    //                     }
    //                 },
    //                 headerSort: false,
    //                 cellClick: function (e, cell) {
    //                     const status = cell.getValue();
    //                     fp.log.verbose({
    //                         type: 'UserEntryDatesPresenterComponent:StatusCellClick',
    //                         status
    //                     });
    //                     if (status) {
    //                         switch (status.StatusCode) {
    //                             case 2:
    //                             case 3:
    //                             case 4:
    //                             case 5:
    //                                 fp.ShowError.emit({
    //                                     open: true,
    //                                     MsgEntityID: status.MsgEntityID
    //                                 });
    //                         }
    //                     }
    //                 }
    //             },
    //             // 2 Selected
    //             {
    //                 title: 'Selected',
    //                 field: 'selected',
    //                 download: false,
    //                 headerSort: false,
    //                 width: fp.selectColumnWidth,
    //                 titleFormatter: () =>
    //                     document.getElementById('cbxColumnHeader'),
    //                 headerClick: () => {
    //                     headerClicked = true;

    //                     const checked = fp.cbxColumnHeader.checked;

    //                     this.log.debug({
    //                         type: 'UserentrydatesPresentersComponent:headerClick',
    //                         rows: this.tabEntryDates.getRows(true).length
    //                     });
    //                     const rows = fp.tabEntryDates.getRows(true);

    //                     rows.forEach(function (row) {
    //                         if (!checked) {
    //                             row.select();
    //                         } else {
    //                             row.deselect();
    //                         }
    //                         row.update({ selected: !checked });
    //                     });

    //                     if (!checked) {
    //                         // TODO: convert this to use css transitions
    //                         $('#divSelectAll').fadeIn(500);
    //                     }

    //                     headerClicked = false;
    //                 },
    //                 formatter: 'tickCross',
    //                 formatterParams: { crossElement: false },
    //                 editor: false,
    //                 selectablePersistence: false,
    //                 cellClick: (e, cell) => {
    //                     const row = cell.getRow();
    //                     row.toggleSelect();
    //                 }
    //             },
    //             // 3 Page Specific Columns
    //             {
    //                 title: 'Username',
    //                 field: 'EmployeeName',
    //                 cssClass: 'tabulator-cell-readonly disabled',
    //                 minWidth: 250
    //             },
    //             {
    //                 title: 'Split Day',
    //                 field: 'Splitday',
    //                 sorter: 'string',
    //                 cssClass: 'tabulator-cell-readonly disabled',
    //                 width: 100
    //             },
    //             {
    //                 title: 'Start Date',
    //                 field: 'MinWorkDate',
    //                 width: 175,
    //                 formatter: 'datetime',
    //                 formatterParams: c => {
    //                     return { outputFormat: 'MM/DD/YYYY' };
    //                 },
    //                 editor: this.tabService.dateEditor
    //             },
    //             {
    //                 title: 'End Date',
    //                 field: 'MaxWorkDate',
    //                 width: 175,
    //                 formatter: 'datetime',
    //                 formatterParams: c => {
    //                     return { outputFormat: 'MM/DD/YYYY' };
    //                 },
    //                 editor: this.tabService.dateEditor
    //             },
    //             {
    //                 title: '',
    //                 field: 'Row_Version',
    //                 visible: false
    //             }
    //         ],
    //         rowSelected: function (row) {
    //             row.update({ selected: true });
    //             if (!headerClicked) {
    //                 checkIndeterminate();
    //             }
    //         },
    //         rowDeselected: function (row) {
    //             row.update({ selected: false });
    //             if (!headerClicked) {
    //                 checkIndeterminate();
    //             }
    //         },
    //         cellEdited: this.tabService.cellEdited,
    //         cellEditing: this.tabService.cellEditing,
    //         cellClick: this.tabService.cellMouseHandler,
    //         cellTap: this.tabService.cellMouseHandler,
    //         rowClick: this.tabService.rowMouseHandler,
    //         rowTap: this.tabService.rowMouseHandler
    //     });
    // }

    public hasErrorStatus = ued =>
        ued && ued.Status && ued.Status.StatusCode >= DisplayMessageMinimum;

    public clearSelectedRows() {
        this.tabEntryDates.deselectRow();
        const data = this.tabEntryDates.getRows();
        data.forEach(d => {
            d.update({ selected: false });
        });
        this.cbxColumnHeader.checked = false;
    }

    public clearFilters() {
        this.tabEntryDates.clearFilter(true);
        this.filterFormGroup.controls['users'].reset();
        this.filterFormGroup.controls['groups'].reset();
        this.resetAction.emit();
    }

    // filterData(filters: any[], fieldName: string, valueName: string) {
    //     this.tabEntryDates.clearFilter(true);

    //     const filtersToApply: Array<
    //         Array<{
    //             field: string;
    //             type: string;
    //             value: any;
    //         }>
    //     > = [[]];

    //     if (filters && filters.length > 0) {
    //         filters.forEach(v => {
    //             filtersToApply[0].push({
    //                 field: fieldName,
    //                 type: '=',
    //                 value: v[valueName]
    //             });
    //         });
    //     }

    //     this.tabEntryDates.setFilter(filtersToApply);
    // }

    tableFilter($event, type) {
        if (type == 'EmployeeName') {
            this.UEDTable.filter($event.value, 'EmployeeListId', 'in');
        }
    }

    onRowSelect($event) {

    }

    onRowUnselect($event) {

    }

    multiUpdate() {
        var arr = [];
        if (this.uedTableSelection.length > 0) {
            this.uedTableSelection.forEach(ele => {
                if (this.selectedStartDate != null) {
                    ele.MinWorkDate = moment(this.selectedStartDate).format('MM/DD/YYYY');
                }
                if (this.selectedEndDate != null) {
                    ele.MaxWorkDate = moment(this.selectedEndDate).format('MM/DD/YYYY');
                }
                arr.push(ele);
            });
            this.MultiSaveEntryDates.next(arr);
        }
        this.uedTableSelection = [];
    }

    onEditInit($event: { data: IUserEntryDate }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: IUserEntryDate) {
        this.clonedEntryDates[rowData.EmployeeListId] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
        if (moment(rowData.MinWorkDate).isValid() == false) {
            this.minWorkDate = new Date();
        } else {
            this.minWorkDate = new Date(rowData.MinWorkDate);
        }
        if (moment(rowData.MaxWorkDate).isValid() == false) {
            this.maxWorkDate = new Date();
        } else {
            this.maxWorkDate = new Date(rowData.MaxWorkDate);
        }
    }

    onRowEditSave(rowData: IUserEntryDate) {
        rowData = {
            ...rowData,
            MinWorkDate: this.minWorkDate != null ? moment(this.minWorkDate).format('MM/DD/YYYY') : rowData.MinWorkDate,
            MaxWorkDate: this.maxWorkDate != null ? moment(this.maxWorkDate).format('MM/DD/YYYY') : rowData.MaxWorkDate,
        };
        this.SaveEntryDates.next(rowData);
        delete this.clonedEntryDates[rowData.EmployeeListId];
        delete this.editing;
        this.log.verbose('onRowEditSave');
        this.minWorkDate = null;
        this.maxWorkDate = null;
    }

    onRowEditCancel(item: IUserEntryDate) {
        delete this.clonedEntryDates[item.EmployeeListId];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }
}
